import { HeroProps } from "../HeroProps";
import Lobby from "../lobby/Lobby";
import { cdnUrl, getComponentFromPath, translate } from "@kaltura/mediaspace-shared-utils";
import { CommonHeroLayout } from "../layout/CommonHeroLayout";

/**
 * media-page player not supported Hero component
 */
export function PlayerNotSupported(props: HeroProps) {
    const { entry, topComponents = [] } = props;

    return (
        <>
            {topComponents.map((topComponent, index) => {
                const { component, props } = topComponent;
                const Component = getComponentFromPath(component);
                return <Component key={index} {...props} />;
            })}
            <CommonHeroLayout>
                <Lobby
                    thumbnailUrl={cdnUrl + "/media/Thumbnail.png"}
                    videoUrl={cdnUrl + "/media/Thumbnail.mp4"}
                    statusLabel={translate("Player version is not supported")}
                    alwaysShowStatusLabel={true}
                    title={entry?.name}
                />
            </CommonHeroLayout>
        </>
    );
}

export default PlayerNotSupported;
